import store from '@/store';

export default {
  getBetName(betting, nameLabel = 'name') {
    const keynameLabels = {
      name: 'keyname',
      typeValue: 'typeValueKeyName',
    };
    if (store.state.usePackageTranslations && betting?.[keynameLabels?.[nameLabel]]) {
      return store.getters.translations[betting[keynameLabels[nameLabel]]];
    }
    return betting?.[nameLabel] || '';
  },
  getOutcomeName(betting, outcomeIndex) {
    if (store.state.usePackageTranslations && betting?.outcomeKeyNames && betting.outcomeKeyNames?.[outcomeIndex]) {
      return store.getters.translations[betting.outcomeKeyNames[outcomeIndex]];
    }
    return betting?.outcomes?.[outcomeIndex] || '';
  },
};
